// extracted by mini-css-extract-plugin
export default {"buttonModal":"style_buttonModal__DqNaD","buttonsRow":"style_buttonsRow__JVuXo"};